<eui-sidebar-toggle *ngIf="(asService.state$ | async).hasSidebar"
                    styleClass="eui-app-toolbar__sidebar-toggle">
</eui-sidebar-toggle>

<ng-content></ng-content>

<ng-container *ngIf="!(asService.state$ | async).hasHeader || ((asService.state$ | async).hasHeader && (asService.breakpoints$ | async).isMobile)">
    <eui-language-selector styleClass="eui-app-toolbar__language-selector">
    </eui-language-selector>
</ng-container>
